module.exports = __webpack_public_path__ + "img/设备界面.b4513109.png";